const translations = {
  "en": {
    "Code verification failed.": "Code verification failed.",
    "Ineligible user status for this code.": "Ineligible user status for this code.",
    "Invalid Code Format.": "Invalid Code Format.",
    "Redemption Failed.": "Redemption Failed.",
    "Redemption time requirement not met.": "Redemption time requirement not met.",
    "Requirements not met to generate code.": "Requirements not met to generate code.",
    "This code has reached its usage limit.": "This code has reached its usage limit.",
    "Too many requests, please try again later.": "Too many requests, please try again later.",
    "You have reached the redemption limit.": "You have reached the redemption limit."
  },
  "zh-tw": {
    "Code verification failed.": "代碼驗證失敗。",
    "Ineligible user status for this code.": "你的帳戶狀態不符合此代碼的使用資格。",
    "Invalid Code Format.": "代碼格式無效。",
    "Redemption Failed.": "兌換失敗。",
    "Redemption time requirement not met.": "未符合兌換時間規定。",
    "Requirements not met to generate code.": "未符合生成代碼的條件。",
    "This code has reached its usage limit.": "此代碼已達使用上限。",
    "Too many requests, please try again later.": "請求過多，請稍後再試。",
    "You have reached the redemption limit.": "你已達兌換上限。"
  }
};

export default translations;
